/** A quote may have a guest range; null max means an open-ended count such as 150+. */
export type GuestCount = { min: number; max: number | null };

export function parseGuestCount(value: string | number | null | undefined): GuestCount | null {
  if (value == null) return null;
  if (typeof value === "number") return Number.isSafeInteger(value) && value >= 0 ? { min: value, max: value } : null;
  const text = value.trim().replace(/^~\s*/, "").replace(/\s+(guests?|people)$/i, "");
  const number = "(?:\\d{1,3}(?:,\\d{3})+|\\d+)";
  const match = text.match(new RegExp(`^(${number})(?:\\s*(?:[-–—]|to)\\s*(${number})|(\\s*\\+))?$`, "i"));
  if (!match) return null;
  const min = Number(match[1].replaceAll(",", ""));
  const max = match[3] ? null : match[2] ? Number(match[2].replaceAll(",", "")) : min;
  if (!Number.isSafeInteger(min) || (max !== null && (!Number.isSafeInteger(max) || max < min))) return null;
  return { min, max };
}

export function formatGuestCount(min: number | null | undefined, max: number | null | undefined): string {
  if (min == null) return "";
  if (max === null) return `${min}+`;
  return max == null || max === min ? String(min) : `${min}–${max}`;
}

/** guestCount remains a compatibility mirror for old readers while range-aware readers use min/max. */
export function leadGuests(lead: { guestCountMin?: number | null; guestCountMax?: number | null; guestCount?: number | null }): GuestCount | null {
  if (lead.guestCountMin != null) return { min: lead.guestCountMin, max: lead.guestCountMax ?? null };
  return lead.guestCount != null ? { min: lead.guestCount, max: lead.guestCount } : null;
}
